import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d457d198"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 2 }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { key: 2 }
const _hoisted_16 = { key: 3 }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dd", null, "RESET", -1))
const _hoisted_18 = [
  _hoisted_17
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`timer ${_ctx.isReset ? 'reset' : ''}`)
  }, [
    (_ctx.error)
      ? (_openBlock(), _createElementBlock("dl", _hoisted_1, [
          _createElementVNode("dd", null, _toDisplayString(_ctx.error[0]), 1),
          _createElementVNode("dt", null, _toDisplayString(_ctx.error[1]), 1)
        ]))
      : (!_ctx.isReset && _ctx.remaining)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (_ctx.mode >= _ctx.modes.years)
              ? (_openBlock(), _createElementBlock("dl", _hoisted_2, [
                  _createElementVNode("dd", null, _toDisplayString(_ctx.zeroPad(_ctx.remaining.months, 2)), 1),
                  (_ctx.mode >= _ctx.modes.years)
                    ? (_openBlock(), _createElementBlock("dt", _hoisted_3, "Yr" + _toDisplayString(_ctx.s(_ctx.remaining.years)), 1))
                    : (_openBlock(), _createElementBlock("dt", _hoisted_4, "Year" + _toDisplayString(_ctx.s(_ctx.remaining.years)), 1))
                ]))
              : _createCommentVNode("", true),
            (_ctx.mode >= _ctx.modes.months)
              ? (_openBlock(), _createElementBlock("dl", _hoisted_5, [
                  _createElementVNode("dd", null, _toDisplayString(_ctx.zeroPad(_ctx.remaining.months, 2)), 1),
                  (_ctx.mode >= _ctx.modes.years)
                    ? (_openBlock(), _createElementBlock("dt", _hoisted_6, "Mth" + _toDisplayString(_ctx.s(_ctx.remaining.months)), 1))
                    : (_openBlock(), _createElementBlock("dt", _hoisted_7, "Month" + _toDisplayString(_ctx.s(_ctx.remaining.months)), 1))
                ]))
              : _createCommentVNode("", true),
            (_ctx.mode >= _ctx.modes.days)
              ? (_openBlock(), _createElementBlock("dl", _hoisted_8, [
                  _createElementVNode("dd", null, _toDisplayString(_ctx.zeroPad(_ctx.remaining.days, 2)), 1),
                  _createElementVNode("dt", null, "Day" + _toDisplayString(_ctx.s(_ctx.remaining.days)), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("dl", null, [
              _createElementVNode("dd", null, _toDisplayString(_ctx.zeroPad(_ctx.remaining.hours, 2)), 1),
              (_ctx.mode >= _ctx.modes.years)
                ? (_openBlock(), _createElementBlock("dt", _hoisted_9, "Hr" + _toDisplayString(_ctx.s(_ctx.remaining.hours)), 1))
                : (_openBlock(), _createElementBlock("dt", _hoisted_10, "Hour" + _toDisplayString(_ctx.s(_ctx.remaining.hours)), 1))
            ]),
            _createElementVNode("dl", null, [
              _createElementVNode("dd", null, _toDisplayString(_ctx.zeroPad(_ctx.remaining.minutes, 2)), 1),
              (_ctx.mode >= _ctx.modes.years)
                ? (_openBlock(), _createElementBlock("dt", _hoisted_11, "Min" + _toDisplayString(_ctx.s(_ctx.remaining.minutes)), 1))
                : (_openBlock(), _createElementBlock("dt", _hoisted_12, "Minute" + _toDisplayString(_ctx.s(_ctx.remaining.minutes)), 1))
            ]),
            _createElementVNode("dl", null, [
              _createElementVNode("dd", null, _toDisplayString(_ctx.zeroPad(_ctx.remaining.seconds, 2)), 1),
              (_ctx.mode >= _ctx.modes.years)
                ? (_openBlock(), _createElementBlock("dt", _hoisted_13, "Sec" + _toDisplayString(_ctx.s(_ctx.remaining.seconds)), 1))
                : (_openBlock(), _createElementBlock("dt", _hoisted_14, "Second" + _toDisplayString(_ctx.s(_ctx.remaining.seconds)), 1))
            ])
          ], 64))
        : (_ctx.isReset && _ctx.remaining && _ctx.remainingTime > 0)
          ? (_openBlock(), _createElementBlock("dl", _hoisted_15, [
              _createElementVNode("dd", null, _toDisplayString(_ctx.zeroPad(_ctx.remaining.hours, 2)) + ":" + _toDisplayString(_ctx.zeroPad(_ctx.remaining.minutes, 2)) + ":" + _toDisplayString(_ctx.zeroPad(_ctx.remaining.seconds, 2)), 1)
            ]))
          : (_ctx.isReset && _ctx.remaining && _ctx.remainingTime == 0)
            ? (_openBlock(), _createElementBlock("dl", _hoisted_16, _hoisted_18))
            : _createCommentVNode("", true)
  ], 2))
}